/**
 * Arabic date formatter (Hijri/Gregorian handled by Intl API).
 * Returns a compact Arabic date string.
 */
const AR = new Intl.DateTimeFormat("ar-EG", {
  day: "numeric", month: "long", year: "numeric",
});
const AR_WITH_TIME = new Intl.DateTimeFormat("ar-EG", {
  day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit",
});

export const formatArDate = (iso, { withTime = false } = {}) => {
  if (!iso) return null;
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return null;
    return (withTime ? AR_WITH_TIME : AR).format(d);
  } catch { return null; }
};

export const relativeAr = (iso) => {
  if (!iso) return null;
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return null;
  const diff = Date.now() - then;
  const mins = Math.round(diff / 60000);
  if (mins < 1) return "الآن";
  if (mins < 60) return `قبل ${mins} د`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `قبل ${hrs} س`;
  const days = Math.round(hrs / 24);
  if (days < 30) return `قبل ${days} يوماً`;
  return formatArDate(iso);
};
